import { NgModule } from '@angular/core';

import {
  CoreUiModule,
} from 'webcommon/core-ui';
import {
  FindControlModule,
} from 'webcommon/find-control';
import {
  ApMacroDatePickerModalComponent,
} from './ap-macro';
import {
  ApMacroEditorComponent,
  ApMacroEditorDetailsComponent,
  ApMacroEditorModalComponent,
  ApTextEditorMacroSelectorComponent,
} from './ap-macro-editor';
import {
  ApTinyEditorComponent,
} from './ap-tiny-editor';
import { ApMacroEditorModalSelectorComponent } from './ap-macro-editor-selector-modal';


const exportComponents = [
  ApMacroEditorModalSelectorComponent,
  ApMacroDatePickerModalComponent,
  ApMacroEditorComponent,
  ApMacroEditorDetailsComponent,
  ApMacroEditorModalComponent,
  ApTextEditorMacroSelectorComponent,
  ApTinyEditorComponent,
];

const declareComponents = [
  ...exportComponents,
];

@NgModule({
  declarations: [
    declareComponents,
  ],
  exports: [
    exportComponents,
  ],
  imports: [
    CoreUiModule,
    FindControlModule,
  ],
})
export class MacroModule {
}
